import {StabilityRuleFormFields} from '@/modules/drug-catalog/stability-rules/components/stability-rule-form/stability-rule-form-fields'
import {StabilityRuleFormDialogOptions} from '@/modules/drug-catalog/stability-rules/constants'
import {DialogBody, DialogHeader} from '@cypro/ui/components'
import {withForm} from '@cypro/ui/integrations/form'

export const StabilityRuleFormDialog = withForm({
  ...StabilityRuleFormDialogOptions,
  render: function Render({form, onSubmit, description, title, ...handlers}) {
    return (
      <>
        <DialogHeader description={description}>{title}</DialogHeader>

        <DialogBody overflow="hidden">
          <form
            onSubmit={onSubmit}
            style={{height: '100%', display: 'flex', flexDirection: 'column', overflow: 'auto'}}
          >
            <form.AppForm>
              <StabilityRuleFormFields form={form} {...handlers} />
            </form.AppForm>
          </form>
        </DialogBody>
      </>
    )
  },
})
